<template>
  <path
    d="M3 17.4602V20.5002C3 20.7802 3.22 21.0002 3.5 21.0002H6.54C6.67 21.0002 6.8 20.9502 6.89 20.8502L17.81 9.94018L14.06 6.19018L3.15 17.1002C3.05 17.2002 3 17.3202 3 17.4602ZM20.71 7.04018C21.1 6.65018 21.1 6.02018 20.71 5.63018L18.37 3.29018C17.98 2.90018 17.35 2.90018 16.96 3.29018L15.13 5.12018L18.88 8.87018L20.71 7.04018Z"
  />
</template>
